import { BaseURlAuth } from "./BaseApiUrl";

export const loginApiURL = BaseURlAuth + "cp/signin/v1/";